import { createTheme } from '@mui/material/styles';

// Couleurs basées sur l'app Android
export const androidColors = {
  // Couleurs principales
  primaryGold: '#F1C086',
  darkGold: '#D4A76A',
  lightGold: '#FFF3E0',
  
  // Couleurs de fond
  darkBackground: '#0A0A0A',
  cardBackground: '#1A1A1A',
  cardBackgroundLight: '#2A2A2A',
  
  // Couleurs de texte
  textColor: '#FFFFFF',
  textSecondary: '#B3B3B3',
  textMuted: '#808080',

  // Couleurs d'accentuation
  borderColor: '#374151',
  success: '#00BFA6',
  error: '#E53935',
  warning: '#FFA726',
  info: '#29B6F6',
};

export const androidTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: androidColors.primaryGold,
      dark: androidColors.darkGold,
      light: androidColors.lightGold,
    },
    background: {
      default: androidColors.darkBackground,
      paper: androidColors.cardBackground,
    },
    text: {
      primary: androidColors.textColor,
      secondary: androidColors.textSecondary,
    },
    success: {
      main: androidColors.success,
    },
    error: {
      main: androidColors.error,
    },
    warning: {
      main: androidColors.warning,
    },
    info: {
      main: androidColors.info,
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2rem',
      fontWeight: 700,
      color: androidColors.textColor,
    },
    h2: {
      fontSize: '1.75rem',
      fontWeight: 700,
      color: androidColors.textColor,
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 700,
      color: androidColors.textColor,
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 700,
      color: androidColors.textColor,
    },
    h5: {
      fontSize: '1.125rem',
      fontWeight: 700,
      color: androidColors.textColor,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      color: androidColors.textColor,
    },
    body1: {
      fontSize: '1rem',
      color: androidColors.textColor,
    },
    body2: {
      fontSize: '0.875rem',
      color: androidColors.textSecondary,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: androidColors.cardBackground,
          border: `1px solid ${androidColors.borderColor}`,
          borderRadius: 12,
          boxShadow: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
        },
        contained: {
          backgroundColor: androidColors.primaryGold,
          color: androidColors.darkBackground,
          '&:hover': {
            backgroundColor: androidColors.darkGold,
          },
        },
        outlined: {
          borderColor: androidColors.primaryGold,
          color: androidColors.primaryGold,
          '&:hover': {
            backgroundColor: `${androidColors.primaryGold}10`,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: androidColors.cardBackground,
            borderRadius: 12,
            '& fieldset': {
              borderColor: `${androidColors.primaryGold}20`,
            },
            '&:hover fieldset': {
              borderColor: `${androidColors.primaryGold}50`,
            },
            '&.Mui-focused fieldset': {
              borderColor: androidColors.primaryGold,
              borderWidth: 2,
            },
          },
          '& .MuiInputLabel-root': {
            color: androidColors.textSecondary,
            '&.Mui-focused': {
              color: androidColors.primaryGold,
            },
          },
          '& .MuiInputBase-input': {
            color: androidColors.textColor,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: androidColors.darkBackground,
          boxShadow: 'none',
          borderBottom: `1px solid ${androidColors.borderColor}`,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: androidColors.cardBackground,
          borderRight: `1px solid ${androidColors.borderColor}`,
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '4px 8px',
          '&:hover': {
            backgroundColor: `${androidColors.primaryGold}10`,
          },
          '&.Mui-selected': {
            backgroundColor: `${androidColors.primaryGold}20`,
            '&:hover': {
              backgroundColor: `${androidColors.primaryGold}30`,
            },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default androidTheme;